import { Routes, Route } from 'react-router-dom'
import App from './App.jsx'
import About from './pages/About.jsx'
import PrivacyPolicy from './pages/PrivacyPolicy.jsx'
import TermsOfUse from './pages/TermsOfUse.jsx'
import DeleteAccount from './pages/DeleteAccount.jsx'
import ResetPassword from './pages/ResetPassword.jsx'
import Admin from './pages/admin.jsx'
import BlogsPage from './pages/BlogsPage.jsx'
import BlogPostPage from './pages/BlogPostPage.jsx'
import { RestaurantSeoRoutePage, ProfileSeoRoutePage, EventSeoRoutePage } from './pages/SeoRoutePages.jsx'
import { CityDiningLandingPage, KeywordLandingPage } from './pages/CityDiningLandingPage.jsx'
import { KEYWORD_LANDING_ROUTES } from './lib/seoRoutes'

export default function AppRouter() {
  return (
    <Routes>
      {KEYWORD_LANDING_ROUTES.map((entry) => (
        <Route
          key={entry.path}
          path={entry.path}
          element={<KeywordLandingPage keywordPath={entry.path} />}
        />
      ))}
      <Route path="/events/:city" element={<EventSeoRoutePage />} />
      <Route path="/restaurants/:city" element={<RestaurantSeoRoutePage />} />
      <Route path="/restaurants/:city/:name" element={<RestaurantSeoRoutePage />} />
      <Route path="/profile/:name" element={<ProfileSeoRoutePage />} />
      <Route path="/events/:city/:eventName" element={<EventSeoRoutePage />} />
      <Route path=":city/find-dining-partner" element={<CityDiningLandingPage />} />
      <Route path="/about" element={<About />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms-of-use" element={<TermsOfUse />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/blogs" element={<BlogsPage />} />
      <Route path="/blogs/:slug" element={<BlogPostPage />} />
      <Route path="/delete-account" element={<DeleteAccount />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="*" element={<App />} />
    </Routes>
  )
}
